<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Products</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row">
            <div class="mr-2">
              <bulk-upload-product />
            </div>
            <div class="mr-2">
              <new-product @created="handleCreated"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row align-items-center">
          <div class="col-12 col-md-6 mb-2" v-if="!selectedRowKeys.length">
            <a-input-search
              placeholder="Search Product..."
              size="large"
              v-model="search"
              @search="searchProduct"
            />
          </div>

          <div class="col-12 col-md-6 mb-2" v-if="!selectedRowKeys.length">
            <div class="row justify-content-around">
              <div class="col">
                <a-select
                  size="large"
                  style="width: 100%"
                  placeholder="All Classes"
                  optionFilterProp="children"
                  v-model="selectedClassId"
                  :filterOption="false"
                  :defaultValue="undefined"
                  @change="handleClassSelect"
                >
                  <a-select-option :value="undefined"
                  >All Classes</a-select-option
                  >
                  <template v-for="schoolClass in schoolClasses">
                    <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                      {{schoolClass.name}}
                    </a-select-option>
                  </template>
                </a-select>
              </div>

              <div class="col">
                <a-select
                  size="large"
                  style="width: 100%"
                  placeholder="All Categories"
                  optionFilterProp="children"
                  v-model="selectedCategoryId"
                  :filterOption="false"
                  :defaultValue="undefined"
                  @change="handleCategorySelect"
                >
                  <a-select-option :value="undefined">
                    All Categories
                  </a-select-option>
                  <template v-for="category in categories">
                    <a-select-option :value="category.id" :key="category.id">
                      {{category.name}}
                    </a-select-option>
                  </template>
                </a-select>
              </div>

              <div class="col">
                <a-select
                  size="large"
                  style="width: 100%"
                  placeholder="All Sub Categories"
                  optionFilterProp="children"
                  v-model="selectedSubCategoryId"
                  :filterOption="false"
                  :defaultValue="undefined"
                  @change="handleSubCategorySelect"
                >
                  <a-select-option :value="undefined">
                    All Sub Categories
                  </a-select-option>
                  <template v-for="subCategory in subCategories">
                    <a-select-option :value="subCategory.id" :key="subCategory.id">
                      {{subCategory.name}}
                    </a-select-option>
                  </template>
                </a-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <products-table :data="data" :rolesetting="pagepermission" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import ProductsTable from '@/components/inventory/master/product/index'
import NewProduct from '@/components/inventory/master/product/new'
import BulkUploadProduct from '@/components/inventory/master/product/Bulk'
import { debounce } from 'lodash'

export default {
  components: {
    ProductsTable,
    NewProduct,
    BulkUploadProduct,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('inventory', 22)
    rc.then(data => {
      // console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  created() {
    this.searchProduct = debounce(this.searchProduct, 500)
  },
  mounted: function() {
    this.getProducts()
    this.getClasses()
    this.getProductCategories()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      search: null,
      selectedRowKeys: [],
      schoolClasses: [],
      allCategories: [], // All categories including sub categories
      categories: [], // Only the main categories i.e. without subcategories
      subCategories: [],
      selectedClassId: undefined,
      selectedCategoryId: undefined,
      selectedSubCategoryId: undefined,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getClasses: function() {
      this.$http.get('/api/class')
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getProductCategories: function() {
      this.$http.get('/api/inventory/category')
        .then(({ data }) => {
          this.allCategories = data.data
          this.categories = this.allCategories.filter((category) => category.parent_category_id === null)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSubCategories: function(selectedCategoryId) {
      this.subCategories = this.allCategories.filter((category) => category.parent_category_id === selectedCategoryId)
    },
    getProducts: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }

      this.$http.get('/api/inventory/product/stock/all', {
        params: {
          class_id: this.selectedClassId,
          category_id: this.selectedCategoryId,
          sub_category_id: this.selectedSubCategoryId,
          limit: this.pageSize,
          page: page,
          search: this.search,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchProduct: function(value) {
      this.search = value
      this.getProducts(true)
    },
    onChangeSearchProducts: function(e) {
      this.search = e.target.value
      this.getProducts(true)
    },
    handleCreated: function() {
      this.getProducts()
    },
    handleUpdateTable: function() {
      this.getProducts()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getProducts()
    },
    onChange(current) {
      this.current = current
      this.getProducts()
    },
    handleClassSelect(selectedClassId) {
      this.getProducts(true)
    },
    handleCategorySelect(selectedCategoryId) {
      this.getProducts(true)
      this.getSubCategories(selectedCategoryId)
    },
    handleSubCategorySelect(selectedSubCategoryId) {
      this.getProducts(true)
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
